import { render, staticRenderFns } from "./InsuranceDisplayCards.vue?vue&type=template&id=64307fb8"
import script from "./InsuranceDisplayCards.vue?vue&type=script&lang=js"
export * from "./InsuranceDisplayCards.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports